import { MoldOrderStatus, MoldOrder } from '../../types/mold';
import { priorityLabelMap } from '../../models/orderLabels';

// Define types for task type mapping
type TaskTypeKey = '2' | '3' | '13' | '4' | '35' | '36';
type TaskTypeValue = string;

export const taskTypeMapping: Record<TaskTypeKey, TaskTypeValue> = {
  '2': 'การล้างผลิต',
  '3': 'การล้างเก็บ (ครบOrder)',
  '13': 'การล้างทั้งระบบเพื่อเก็บ',
  '4': 'การล้างทั้งระบบเพื่อผลิตต่อ',
  '35': 'การล้างเก็บ และปิด Mold',
  '36': 'การล้างเก็บ และ EOL',
};

export const REQUIRE_PHOTO_TAGS = ['before_core', 'before_cavity', 'after_core', 'after_cavity'];

export const isFinalStep = (status: MoldOrderStatus): boolean => {
  return [
    MoldOrderStatus.DONE,
    MoldOrderStatus.END_REJECTED,
    MoldOrderStatus.COMPLETED,
  ].includes(status);
};

export const formatNumberWithCommas = (number: number): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatDateLocale = (date: string | Date): string => {
  return new Date(date).toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const getDisplayTaskType = (taskType: TaskTypeKey): string => {
  return taskTypeMapping[taskType] || 'การล้าง';
};

export const canSetPriority = (status: MoldOrderStatus): boolean => {
  return [
    MoldOrderStatus.PICK_UP,
    MoldOrderStatus.PENDING_ACKNOWLEDGE,
    MoldOrderStatus.CREATED,
  ].includes(status);
}

export const getDisplayReviewInfo = (moldOrder: MoldOrder) => {
  if ([MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED].includes(moldOrder.status)) {
    const size = moldOrder.stateInstances.length
    if (size > 0) {
      const lastState = moldOrder.stateInstances[size - 2]
      return {
        reason: lastState.notes || '',
        reviewer: lastState.assignedTo,
        reviewedAt: lastState.updatedAt,
      }
    }
  }

  return {
    reason: '',
    reviewer: null,
  }
}

export const getPriorityLabel = (priority: number) => {
  return priorityLabelMap[String(priority)] ?? priorityLabelMap.default;
}

export const getPriorityColor = (priority: number) => {
  switch (priority) {
    case 1: return 'text-red-500';
    case 100: return 'text-red-400';
    default: return 'text-black';
  }
}

export const getPriorityBgColor = (priority: number) => {
  switch (priority) {
    case 1: return 'bg-red-100';
    case 100: return 'bg-red-50';
    default: return 'bg-white';
  }
}